import React, { Component } from 'react';

import { LayoutContext } from '../../../../../../modules/ContextModules/LayoutContext';
import DataManageModule from '../../../../../../modules/DataManageModule/DataManageModule';
import ApiOviewDocmd from '../../../../../../modules/WebApiModules/ApiOviewDocmd';
import visible from './.image/Visible.png'
import unVisible from './.image/Unvisible.png'
import edit from './.image/edit.png'
import deletePng from './.image/delete.png'

import './KMLItem.css'
import { AutoTruncateTextLabel } from '../../../../../.common/AutoTruncateTextLabel/AutoTruncateTextLabel';
import { AttributesTable } from '../../../../../.common/AttributesTable/AttributesTable';
export class KMLItem extends Component {
    static contextType = LayoutContext;
    constructor(props) {
        super(props);

        this.state = {
            isEdit: false,
            editText:this.props.data.name
        }

        this.kmlSceneInstance = this.props.data.instance;
        console.log("new");
        // this.state = {
        //     opened: this.props.data.opened,
        // }
    }

    componentDidMount() {
        this.updateKml();
    }

    componentDidUpdate() {
        this.updateKml();
    }

    componentWillUnmount() {
        this.closeKml();
    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <div className='kmlItem'>{
                this.state.isEdit ? <input type="text" value={this.state.editText} onChange={(e) => { this.setState({ editText:e.target.value}); }} /> :
                <AutoTruncateTextLabel data={{
                    text: this.props.data.name,
                    style: { width: 'calc(100% - 75px)' }
                }} />
            }
                <div>
                    <img src={edit} width={25} height={25} onClick={this.toggleEditImage} />
                    <img src={deletePng} width={25} height={25} onClick={this.toggleDeleteImage} />
                    <img src={this.updateOpenedImage()} width={25} height={25} onClick={this.toggleOpenedImage} />
                </div>
            </div>
        );
    }

    updateOpenedImage = () => {
        if (this.props.data.isOpened === true) {
            return visible;
        }
        return unVisible;
    }

    toggleOpenedImage = () => {
        const { kmlUploadContext } = this.context;
        kmlUploadContext.toggleOpened(this.props.data.name);
    }

    toggleDeleteImage = () => {
        const { kmlUploadContext } = this.context;
        ApiOviewDocmd.Docmd("CMD_DeleteKMLName", { name: this.props.data.name }, /*success*/(res) => {

            let nowIndex = -1;
            let newList = kmlUploadContext.kmlList.map((kml, index) => {
                if (kml.name === this.props.data.name) {
                    nowIndex = index;
                }
                return { name: kml.name, isOpened: false }
            });

            newList.splice(nowIndex, 1);
            kmlUploadContext.updateContextList(newList);
        }, /*failed*/() => { });
    }

    toggleEditImage = () => {
        const { kmlUploadContext } = this.context;
        let text = this.state.editText;
        let ext = text.substring(text.length - 4, text.length);
        if (this.state.isEdit) {
            if (text === this.props.data.name) {
                this.setState({ isEdit: false });
                return;
            }

            if (ext !== ".kml") {
                window.alertify.log("副檔名必須為kml。");
                return;
            }

            for (const kml of kmlUploadContext.kmlList) {
                if (kml.name !== this.props.data.name &&
                    text === kml.name) {
                    window.alertify.log("編輯後名稱重複。");
                    return;
                }
            }

            ApiOviewDocmd.Docmd("CMD_UploadKMLName", { oldName: this.props.data.name, newName: text }, /*success*/(res) => {
                let newList = kmlUploadContext.kmlList.map((kml, index) => {
                    if (kml.name === this.props.data.name) {
                        return { name: text, isOpened: false }
                    }
                    return { name: kml.name, isOpened: false }
                });
               kmlUploadContext.updateContextList(newList); 
                
                
        }, /*failed*/() => { });
        }
        else {
            window.alertify.log("編輯檔案名稱，在點擊一次編輯按鈕完成編輯。");
            this.setState({ isEdit: true });
        }
        //ApiOviewDocmd.Docmd("CMD_UploadKMLName", { oldName: this.props.data.name,newName:"" }, /*success*/(res) => {
        //}, /*failed*/() => { });


    }

    updateKml = () => {
        if (this.props.data.isOpened === true) {
            this.openKml();
        } else {
            this.closeKml();
        }
    }

    openKml = () => {
        const { kmlUploadContext } = this.context;
        if (!this.kmlSceneInstance) {
            ApiOviewDocmd.Docmd("CMD_GetKMLContent", { name: this.props.data.name }, /*success*/(res) => {
                console.log(res);
                //匯入KML
                let file = DataManageModule.ConvertB64toBlob(res.result)
                window.gMainMap.TerrainView.importKML({
                    url: this.getObjectURL(file),
                    callback: (scene) => {
                        this.kmlSceneInstance = scene;
                        this.kmlSceneInstance.setOnClickEntity(this.handleKMLEntityClick);
                        kmlUploadContext.copyByRef(this.props.data.name, scene)
                    }
                });
            }, /*failed*/() => { });
        }
    }

    handleKMLEntityClick = (param, pos) => {
        const { attributesModalContext } = this.context;
        let list = [
            { key: "名稱", value: param.name, show: this.props.showAttributes["名稱"] },
            { key: "電話", value: param.phone, show: this.props.showAttributes["電話"] },
            { key: "地址", value: param.address, show: this.props.showAttributes["地址"] },
            { key: "描述", value: param.description, show: this.props.showAttributes["描述"] },
        ];

        let content = (
            <AttributesTable list={list} />
        );

        attributesModalContext.updateContent({ content: content, position: { x: `${pos.x + 10}px`, y: `${pos.y - 25}px` } });
    }

    closeKml = () => {
        if (this.kmlSceneInstance) {
            //清除KML
            window.gMainMap.TerrainView.removeKMLScene(this.kmlSceneInstance);
            this.kmlSceneInstance = null;
        }
    }

    getObjectURL = (file) => {
        var url = null;
        if (window.createObjcectURL !== undefined) {
            url = window.createObjectURL(file);
        } else if (window.URL !== undefined) {
            url = window.URL.createObjectURL(file);
        } else if (window.webkitURL !== undefined) {
            url = window.webkitURL.createObjectURL(file);
        }
        return url;
    }
}